import styled from "styled-components";

import { ModalIcon, SmallModalTemplate } from "shared/ui/modals";
import { DirectSendIcon } from "shared/ui/icons";
import { useStore } from "effector-react";

import { Button } from "shared/ui/button";

import { $formSubmittedEmail } from "../models/forgot-password-form-model";

export function ForgotPasswordFormSuccessModal(props: {
  isOpened: boolean;
  onClose(): void;
}): JSX.Element {
  const formSubmittedEmail = useStore($formSubmittedEmail);

  return (
    <SmallModalTemplate
      onClose={props.onClose}
      isOpened={props.isOpened}
      renderTitle={() => "Password recovery"}
      renderContent={() => (
        <InfoModalContent>
          <ModalIcon as={DirectSendIcon} />
          <EmailInfo>
            <EmailTitle>Your email</EmailTitle>
            <Email>{formSubmittedEmail}</Email>
          </EmailInfo>

          <div>We have sent you an email with instructions.</div>
        </InfoModalContent>
      )}
      renderActions={({ close }) => <Button onClick={close}>Back</Button>}
    />
  );
}

const EmailTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #5e88ef;
`;

const Email = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: #0a1128;
`;

const EmailInfo = styled.div`
  ${EmailTitle} {
    margin-bottom: 4px;
  }
`;

const InfoModalContent = styled.div`
  ${EmailInfo} {
    margin-bottom: 16px;
  }
`;
